import React from 'react'

export default function TaggerHeaderTeamStatsPenalty({ penalty, showNumber }) {
    return (
        <div className="penalty">
            <div className="num">{showNumber ? penalty.player : '--'}</div>
            <div className="pen-time">{`${penalty.minutes}:${penalty.seconds}`}</div>
        </div>
    )
}